









import Vue from 'vue';
import { Avatar } from '@descomplica/vue-components';

export default Vue.extend({
  components: { Avatar },
  props: {
    name: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    onSignOutButtonClick: {
      type: Function,
      default: () => true,
    },
  },
});
